export type ArticleTag = 'Juridisch' | 'Werkgever' | 'Preventie' | 'Basis';

export type Article = {
  slug: string;
  tag: ArticleTag;
  title: string;
  desc: string;
  readTime: number;
};

export const ARTICLE_FILTERS = [
  { id: 'alle', label: 'Alle artikelen', tag: null },
  { id: 'juridisch', label: 'Juridisch', tag: 'Juridisch' },
  { id: 'werkgevers', label: 'Voor Werkgevers', tag: 'Werkgever' },
  { id: 'preventie', label: 'Preventie', tag: 'Preventie' },
  { id: 'basis', label: 'Basis', tag: 'Basis' },
] as const;

export type ArticleFilterId = (typeof ARTICLE_FILTERS)[number]['id'];

export const ARTICLES: Article[] = [
  { slug: 'or-en-vertrouwenspersoon-arbowet-raadplegingsplicht', tag: 'Juridisch', title: 'De OR en de vertrouwenspersoon: nieuwe Arbowet en raadplegingsplicht', desc: 'Sinds 1 juli 2026 moet de werkgever de OR raadplegen over arbobeleid. Wat betekent dat voor het aanstellen van een vertrouwenspersoon?', readTime: 3 },
  { slug: 'vertrouwenspersoon-verplicht', tag: 'Juridisch', title: 'Is een vertrouwenspersoon verplicht in 2025 en 2026?', desc: 'Een vertrouwenspersoon is op dit moment niet wettelijk verplicht, maar in de praktijk wordt het steeds vaker verwacht. Lees hoe het juridisch zit.', readTime: 4 },
  { slug: 'interne-vs-externe-vertrouwenspersoon', tag: 'Werkgever', title: 'Interne vs. externe vertrouwenspersoon: 5 redenen voor extern', desc: 'Medewerkers melden liever extern. Dit zijn de vijf belangrijkste redenen waarom een externe vertrouwenspersoon effectiever is.', readTime: 5 },
  { slug: 'wat-kost-een-externe-vertrouwenspersoon', tag: 'Werkgever', title: 'Wat kost een externe vertrouwenspersoon?', desc: 'Een compleet abonnement vanaf €375 per jaar. Wat zit er in en hoe verhoudt het zich tot de kosten van een interne oplossing?', readTime: 3 },
  { slug: 'ongewenst-gedrag-herkennen', tag: 'Preventie', title: 'Ongewenst gedrag herkennen vóórdat het escaleert', desc: 'Wachten op een melding is al te laat. Zo pak je het preventief aan met vroegsignalering en de juiste tools.', readTime: 6 },
  { slug: 'wat-doet-een-vertrouwenspersoon', tag: 'Basis', title: 'Wat doet een vertrouwenspersoon precies?', desc: 'De vertrouwenspersoon luistert, begeleidt en signaleert. Maar lost het probleem niet op. Wat kun je precies verwachten?', readTime: 4 },
  { slug: 'verschil-vertrouwenspersoon-mediator', tag: 'Basis', title: 'Wat is het verschil tussen een vertrouwenspersoon en een mediator?', desc: 'Twee verschillende rollen die vaak worden verward. Een heldere uitleg over wat ze wel en niet doen.', readTime: 3 },
];

export function isArticleFilterId(value: string | null): value is ArticleFilterId {
  return ARTICLE_FILTERS.some((filter) => filter.id === value);
}

export function matchesArticleQuery(
  article: Pick<Article, 'title' | 'desc' | 'tag'>,
  query: string,
): boolean {
  const needle = query.trim().toLowerCase();
  if (!needle) return true;

  return [article.title, article.desc, article.tag].some((value) =>
    value.toLowerCase().includes(needle),
  );
}

export function filterArticles(
  articles: Article[],
  categoryId: ArticleFilterId,
  query: string,
): Article[] {
  const filter = ARTICLE_FILTERS.find((item) => item.id === categoryId) ?? ARTICLE_FILTERS[0];

  return articles.filter((article) => {
    if (filter.tag && article.tag !== filter.tag) return false;
    return matchesArticleQuery(article, query);
  });
}
